import React, { FC, HTMLAttributes, useMemo } from "react";
import clsx from "classnames";
import { useStyles } from "./Icon.style";
import { getMediaSizeScale } from "../../../models/screen";
interface IIconProps {
  name?: IconName;
  size?: number;
  hoverEffect?: boolean;
}

export const iconsList = [
  "icon-profile-circle3",
  "icon-arrow-left",
  "icon-arrow-right",
  "icon-refresh",
  "icon-wifi",
  "icon-check",
  "icon-close",
  "icon-add",
  "icon-bold-add",
  "icon-arrow-down",
  "icon-notification",
  "icon-setting",
  "icon-arrow-up",
  "icon-category",
  "icon-game",
  "icon-game-bold",
  "icon-monitor",
  "icon-music",
  "icon-people",
  "icon-search",
  "icon-logout",
  "icon-linear-arrow-left-3",
];

export type IconName = (typeof iconsList)[number];

const IconComponent: FC<IIconProps & HTMLAttributes<HTMLSpanElement>> = ({
  name,
  size = 24,
  hoverEffect = false,
  ...otherProps
}) => {
  const classes = useStyles();

  const computedStyle = useMemo(
    () => ({
      ...otherProps.style,
      fontSize: size * getMediaSizeScale(),
      lineHeight: `${size * getMediaSizeScale()}px`,
    }),
    [otherProps.style, size],
  );

  if (!name) return null;

  // Decorative unless labelled or clickable
  const isNamed = !!(otherProps["aria-label"] || otherProps["aria-labelledby"]);
  const a11yProps =
    isNamed || otherProps.onClick
      ? otherProps.onClick
        ? { role: "button", tabIndex: -1 }
        : { role: "img" }
      : { "aria-hidden": true };

  return (
    <span
      {...a11yProps}
      {...otherProps}
      style={computedStyle}
      className={clsx(
        classes.root,
        otherProps.className,
        name,
        hoverEffect && classes.hoverEffect,
      )}
    />
  );
};

export const Icon = React.memo(IconComponent);
